import { createSelector } from "reselect";

import Course from "../models/state/courses/course/Course";
import { SectionId, Sections } from "../models/state/sections/Sections";
import { getAllSections, getCourse } from "./state";

type State = any;

export function makeGetSectionNumber(
  courseId: string,
  sectionId: string
): (arg0: State) => string {
  return createSelector(
    (state: any) => getCourse(state, courseId),
    getAllSections,
    (course, sections) => getSectionNumber(course, sections, sectionId)
  );
}

export function getSectionNumber(
  course: Course,
  sections: Sections,
  sectionId: SectionId
): string {
  const section = sections.get(sectionId);
  const parentId = section?.parentId;

  if (!parentId) return "";

  if (parentId === course.id) {
    return `${course.sectionIds.indexOf(sectionId) + 1}`;
  }

  const parent = sections.get(parentId);

  if (!parent) return "";

  const parentNumber = getSectionNumber(course, sections, parentId);
  return `${parentNumber}.${parent.sectionIds.indexOf(sectionId) + 1}`;
}
